import { lazy } from "react";
import { meritoImport } from "../_step/MeritoImportModal";

export const sections = [
  {
    id: "beneficiaries",
    title: "Projeto e Beneficiário(s)",
    component: lazy(() => import("./01_Beneficiaries")),
  },
  {
    id: "stepFraming",
    title: "Enquadramento STEP",
    component: lazy(() => import("./02_StepFraming")),
  },
  {
    id: "beneficiaryData",
    title: "Dados do Beneficiário",
    component: lazy(() => import("./03_BeneficiaryData")),
  },
  {
    id: "economic",
    title: "Unidade Económica",
    component: lazy(() => import("./04_EconomicUnit")),
  },
  {
    id: "marketAnalysis",
    title: "Análise Mercado",
    component: lazy(() => import("./05_MarketAnalysis")),
  },
  {
    id: "balance",
    title: "Balanço e DR",
    component: lazy(() => import("./06_BalanceDR")),
  },
  {
    id: "project",
    title: "Dados do Projeto",
    component: lazy(() => import("./07_ProjectData")),
  },
  {
    id: "operation",
    title: "Caracterização da Operação",
    component: lazy(() => import("./08_OperationDescription")),
  },
  {
    id: "operationInnovations",
    title: "Inovações introduzidas pela operação",
    component: lazy(() => import("./09_OperationInnovations")),
  },
  {
    id: "actions",
    title: "Detalhe das Ações",
    component: lazy(() => import("./10_Actions")),
  },
  {
    id: "activities",
    title: "Atividades e Indicadores",
    component: lazy(() => import("./11_Activities")),
  },
  {
    id: "technicians",
    title: "Pessoal técnico",
    component: lazy(() => import("./12_Technicians")),
  },
  {
    id: "team",
    title: "Equipa",
    component: lazy(() => import("./13_TechniciansCosts")),
  },
  {
    id: "salaryCosts",
    title: "Custos Salariais",
    component: lazy(() => import("./14_SalaryCosts")),
  },
  { id: "costs", title: "Custos", component: lazy(() => import("./15_Costs")) },
  {
    id: "amortizations",
    title: "Amortização",
    component: lazy(() => import("./16_Amortization")),
  },
  {
    id: "financing",
    title: "Financiamento",
    component: lazy(() => import("./17_Financing")),
  },
  {
    id: "selectionCriteria",
    title: "Critérios de Seleção",
    component: lazy(() => import("./18_SelectionCriteria")),
  },
  {
    id: "declarations",
    title: "Declarações",
    component: lazy(() => import("./19_Declarations")),
  },
];

// Mérito file "Apuramento Despesa I&D&I" (see ../_step/meritoImport.js).
export const importFiles = {
  Mérito: meritoImport({
    teamYears: ["2026", "2027", "2028", "2029"],
    teamComponent: true,
  }),
};
